import React, { createContext, useReducer } from "react";
const initialMetaData = [
  {
    id: 1,
    parentId: [],
    parentGlobalId: [],
    order: 1,
    type: "Form",
    properties: { 
      name: {value: "Form",  control:"TextBox"},
      text: {value: "Form",  control:"TextBox"},
      actions: {value: "",  control:"TextBox"},
      actualize: {value: 0,  control:"TextBox", hide:true},
    },
    policy: { read: true, edit: true, delete: true },
    metaData: [],
    styles: {
      color: {value:"#212121"},
      backgroundColor: {value:"white"},
      width: {value:"1000px"},
      height: {value:"500px"},
      position: {value:"relative", hide:true},
      border: {value:"1px solid #cccccc"},
      resize: {value:"auto", hide:true},
      margin: {value:"0 auto", hide:true},
      borderRadius: {value:"0px"},
    },
  },
]
const initialState = {
  processItems: {
    lists: {
      Steps: [
        {
          id: 999,
          globalId:"4fae2036-8ee7-4d0a-9e10-33f6d6d591df",
          item: "End",
        },
      ],
      Decisions: [],
      menuSteps: {
        width: "175px",
        list: [
          {
            id: 1,
            item: "Settings Step",
            action: {
              type: "SettingsParent",
              icon: "Open",
              form: "",
            },
          },
          {
            id: 2,
            item: "Add Next Node",
            action: { type: "AddNewParent", icon: "Add" },
            template: {
              id: 0,
              order: 0,
              isExpanded: false,
              isChecked: true,
              policy: { read: true, edit: true, delete: true },
              menu: "menuSteps",
              items: {
                width: { 1: "100%" },
                data: [
                  {
                    id: 0,
                    item: { id: 0, item: "New Step" },
                    order: 1,
                    isChecked: true,
                    list: "Steps",
                  },
                ],
              },
              childs: [],
            },
          },
          {
            id: 5,
            item: "Add Child Node",
            action: { type: "AddUnderParent", icon: "Add" },
            template: {
              decision: {
                id: 0,
                order: 0,
                isExpanded: true,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuDecision",
                items: {
                  width: { 1: "100%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 0, item: "New Step" },
                      order: 1,
                      isChecked: true,
                      list: "Steps",
                    },
                  ],
                },
                childs: [],
              },
              step: {
                id: 0,
                order: 0,
                isExpanded: false,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuSteps",
                items: {
                  width: { 1: "100%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 0, item: "New Step" },
                      order: 1,
                      isChecked: true,
                      list: "Steps",
                    },
                  ],
                },
                childs: [],
              },
            },
          },
          {
            id: 4,
            item: "Add Decision Node",
            action: { type: "AddChild", icon: "Add" },
            template: {
              decision: {
                id: 0,
                order: 0,
                isExpanded: true,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuDecision",
                items: {
                  width: { 1: "30%", 2: "70%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 1, item: "New Decision" },
                      order: 1,
                      isChecked: true,
                      list: "Decisions",
                      filtered: true,
                    },
                    {
                      id: 0,
                      item: {
                        id: 0,
                        item: "New Step",
                      },
                      order: 2,
                      isChecked: true,
                      list: "Steps",
                      filtered: false,
                    },
                  ],
                },

                childs: [],
              },
              step: {
                id: 0,
                order: 0,
                isExpanded: false,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuSteps",
                items: {
                  width: { 1: "100%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 0, item: "New Step" },
                      order: 1,
                      isChecked: true,
                      list: "Steps",
                    },
                  ],
                },
                childs: [],
              },
            },
          },
          {
            id: 3,
            item: "Delete Current Node",
            action: { type: "DeleteParent", icon: "Delete" },
          },
          {
            id: 6,
            item: "Cascade delete",
            action: { type: "CascadeDeleteParent", icon: "Delete" },
          },
        ],
      },
      menuDecision: {
        width: "160px",
        list: [
          {
            id: 3,
            item: "Delete Decison",
            action: { type: "DeleteChild", icon: "Delete" },
          },
        ],
      },
      currentMaxId: 1,
    },
    data: [],
  },
  organigramItems: {
    lists: {
      Steps: [
        {
          id: 999,
          item: "End",
        },
      ],
      Decisions: [],
      menuSteps: {
        width: "175px",
        list: [
          {
            id: 1,
            item: "Settings Users",
            action: {
              type: "SettingsParent",
              icon: "Open",
              form: "",
            },
          },
          {
            id: 2,
            item: "Add Next Node",
            action: { type: "AddNewParent", icon: "Add" },
            template: {
              id: 0,
              order: 0,
              isExpanded: true,
              isChecked: true,
              policy: { read: true, edit: true, delete: true },
              menu: "menuSteps",
              items: {
                width: { 1: "100%" },
                data: [
                  {
                    id: 0,
                    item: { id: 0, item: "New Step" },
                    order: 1,
                    isChecked: true,
                    list: "Steps",
                  },
                ],
              },
              childs: [],
            },
          },
          {
            id: 5,
            item: "Add Child Node",
            action: { type: "AddUnderParent", icon: "Add" },
            template: {
              decision: {
                id: 0,
                order: 0,
                isExpanded: true,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuDecision",
                items: {
                  width: { 1: "100%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 0, item: "New Step" },
                      order: 1,
                      isChecked: true,
                      list: "Steps",
                    },
                  ],
                },
                childs: [],
              },
              step: {
                id: 0,
                order: 0,
                isExpanded: false,
                isChecked: true,
                policy: { read: true, edit: true, delete: true },
                menu: "menuSteps",
                items: {
                  width: { 1: "100%" },
                  data: [
                    {
                      id: 0,
                      item: { id: 0, item: "New Step" },
                      order: 1,
                      isChecked: true,
                      list: "Steps",
                    },
                  ],
                },
                childs: [],
              },
            },
          },
          {
            id: 3,
            item: "Delete Current Node",
            action: { type: "DeleteParent", icon: "Delete" },
          },
          {
            id: 6,
            item: "Cascade delete",
            action: { type: "CascadeDeleteParent", icon: "Delete" },
          },
        ],
      },
      menuDecision: {
        width: "160px",
        list: [
          {
            id: 3,
            item: "Delete Decison",
            action: { type: "DeleteChild", icon: "Delete" },
          },
        ],
      },
      currentMaxId: 1,
    },
    data: [],
  },
  tools: [
    {
      id: 1,
      type: "Actions",
      items: [
        {
          id: 2,
          name: "Button",
          template: {
            id: 0,
            order: 0,
            type: "Button",
            properties: { 
              name: {value: "Button",  control:"TextBox"},
              text: {value: "Button",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"white"},
              
              visibility: {value:"visible"},
              borderLeft: {value:"none"},
              borderTop: {value:"none"},
              borderTopLeftRadius: {value:"2px"},
              borderTopRightRadius: {value:"2px"},
              borderRight: {value:"none"},
              borderBottom: {value:"none"},
              borderBottomLeftRadius: {value:"2px"},
              borderBottomRightRadius: {value:"2px"},
                              
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"100px"},
              outline: {value:"none", hide:true},
              backgroundColor: {value:"#008dff"}, 
             
            },
          },
         
        },
        {
          id: 3,
          name: "SideBar",
          template: {
            id: 0,
            order: 0,
            type: "SideBar",
            properties: { 
              name: {value: "SideBar" ,  control:"TextBox"}, 
              text: {value: "SideBar" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"none"},
              left: {value:0, hide:true},
              top: {value:0, hide:true},
              width: {value:"100", hide:true},
              height: {value:"100", hide:true},
              outline: {value:"none", hide:true},
            },
          },
        },
        {
          id: 4,
          name: "ToolBar",
          template: {
            id: 0,
            order: 0,
            type: "ToolBar",
            properties: { 
              name: {value: "ToolBar" ,  control:"TextBox"}, 
              text: {value: "ToolBar",  control:"TextBox"},
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              resize: {value:"Vertical", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"none"},
              background:{value:"white"},
             
              
              left: {value:0, hide:true},
              top: {value:0, hide:true},
              width: {value:"100%", hide:true},
              height: {value:"50px"},
              outline: {value:"none", hide:true},
            },
          },
        },
        {
          id: 28,
          name: "MenuItem",
          template: {
            id: 0,
            order: 0,
            type: "MenuItem",
            properties: {
              name: {value: "MenuItem",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              menuItem: {value: true ,  control:"CheckBox", hide:true},
              width: {value: "200px" ,  control:"TextBox"},
              type: {value: "String" ,  control:"ListBox" , hide:true},
              toolTip: {value: false ,  control:"CheckBox", hide:true},
              toolTipText: {value: "" ,  control:"TextBox", hide:true},
              actualize: {value: 0,  control:"TextBox", hide:true},
              nullable: {value: true ,  control:"CheckBox", hide:true},
              text: {value: "ListBox",  control:"TextBox", hide:true},
              index: {value: false ,  control:"CheckBox", hide:true},
              data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}}, options:["Tree"], control:"TextBox"}
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"25px"},
              display: {value:"flex", hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
      ],
    },
    {
      id: 5,
      type: "Containers",
      items: [
        {
          id: 6,
          name: "GroupBox",
          template: {
            id: 0,
            order: 0,
            type: "GroupBox",
            properties: { 
              name: {value: "GroupBox",  control:"TextBox"}, 
              text: {value: "GroupBox",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}
             },
            policy: { read: true, edit: true, delete: true },
            metaData: [],
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              visibility: {value:"visible"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"100px"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"1px solid #cccccc"},
              background: {value:"white"},
            },
          },
        },
        {
          id: 26,
          name: "Panel",
          template: {
            id: 0,
            order: 0,
            type: "Panel",
            properties: { 
              name: {value: "Panel",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              text: {value: "Panel",  control:"TextBox"} },
            policy: { read: true, edit: true, delete: true },
            metaData: [],
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              visibility: {value:"visible"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"100px"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"1px solid #cccccc"},
              background: {value:"white"},
              borderRadius: {value:"Opx"},
            },
          },
        },
        {
          id: 21,
          name: "TabPanel",
          template: {
          id: 0,
          order: 0,
          type: "TabPanel",
          properties: { 
            name: {value: "TabPanel",  control:"TextBox"},
            actions: {value: "",  control:"TextBox"}, 
            text: {value: "TabPanel",  control:"TextBox"} },
          policy: { read: true, edit: true, delete: true },
          panelTemplate:{
            id: 0,
            order: 0,
            type: "GroupBox",
            properties: { 
              name: {value: "Panel",  control:"TextBox"}
            , text: {value: "Panel",  control:"TextBox"} 
          },
            policy: { read: true, edit: true, delete: true },
            metaData: [],
            styles: {
              fontSize: {value:"14px"},
              color: {value:"rgba(73, 80, 87)"},
              left: {value:0},
              top: {value:0},
              border: {value:"1px solid #cccccc"},
              backgroundColor: {value:"white"},
            },         
          },
          metaData: [
            {
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "Panel",  control:"TextBox"}, 
                text: {value: "Panel",  control:"TextBox"} },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0},
                top: {value:0},
                   
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
              },
               
              }
            ],
          styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              color: {value:"#008dff"},
              visibility: {value:"visible"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"400px"},
              height: {value:"200px"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"none"},
              background: {value:"rgba(248, 249, 250)"},
            },
          },
        },
        {
          id: 24,
          name: "ListView",
          template: {
          id: 0,
          order: 0,
          type: "ListView",
          properties: { 
            name: {value: "ListView",  control:"TextBox"}, 
            text: {value: "ListView",  control:"TextBox"},
            actions: {value: "",  control:"TextBox"},
            accordion: {value: true,  control:"CheckBox"},
          },
          panelTemplate:{
            id: 0,
            order: 0,
            type: "GroupBox",
            properties: { 
              name: {value: "ListView",  control:"TextBox"}, 
              text: {value: "ListView",  control:"TextBox"},
              collapse: {value: false,  control:"CheckBox"}, 
            },
            policy: { read: true, edit: true, delete: true },
            metaData: [],
            styles: {
              fontSize: {value:"14px"},
              color: {value:"rgba(73, 80, 87)"},
              left: {value:0},
              top: {value:0},
              height: {value:"20px"},
              position: {value:"absolute"},
              border: {value:"1px solid #cccccc"},
              backgroundColor: {value:"white"},
              resize: {value:"Vertical"},
              overflow: {value:"auto"},
            },
          },
          policy: { read: true, edit: true, delete: true },
          metaData: [
            {
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "ListView",  control:"TextBox"}, 
                text: {value: "ListView",  control:"TextBox"},
                collapse: {value: false,  control:"CheckBox"}, 
              },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0},
                top: {value:0},
                height: {value:"20px"},
                position: {value:"absolute"},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
                resize: {value:"Vertical"},
                overflow: {value:"auto"},
              },
            },
          ],
          styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              color: {value:"#008dff"},
              visibility: {value:"visible"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"400px"},
              height: {value:"200px"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"none"},
              background: {value:"rgba(248, 249, 250)"},
            },
          },
        },
        {
          id: 25,
          name: "SplitListView",
          template: {
          id: 0,
          order: 0,
          type: "SplitListView",
          properties: { 
            name: {value: "SplitListView",  control:"TextBox"}, 
            text: {value: "SplitListView",  control:"TextBox"},
            actions: {value: "",  control:"TextBox"},
          },
          panelTemplate:{
            id: 0,
            order: 0,
            type: "GroupBox",
            properties: { 
              name: {value: "SplitListView",  control:"TextBox"}, 
              text: {value: "SplitListView",  control:"TextBox"} },
              policy: { read: true, edit: true, delete: true },
            metaData: [],
            styles: {
              fontSize: {value:"14px"},
              color: {value:"rgba(73, 80, 87)"},
              left: {value:0, hide:true},
              top: {value:0, hide:true},
              height: {value:"40px"},
              width: {value:"40px"},
              position: {value:"absolute", hide:true},
              border: {value:"1px solid #cccccc"},
              backgroundColor: {value:"white"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
          policy: { read: true, edit: true, delete: true },
          metaData: [
            {
              id: 0,
              order: 0,
              type: "GroupBox",
              properties: { 
                name: {value: "SplitListView",  control:"TextBox"}, 
                text: {value: "SplitListView",  control:"TextBox"} },
              policy: { read: true, edit: true, delete: true },
              metaData: [],
              styles: {
                fontSize: {value:"14px"},
                color: {value:"rgba(73, 80, 87)"},
                left: {value:0, hide:true},
                top: {value:0, hide:true},
                height: {value:"40px"},
                width: {value:"40px"},
                position: {value:"absolute", hide:true},
                border: {value:"1px solid #cccccc"},
                backgroundColor: {value:"white"},
                resize: {value:"both", hide:true},
                overflow: {value:"auto", hide:true},
              },
            },
          ],
          styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              color: {value:"#008dff"},
              visibility: {value:"visible"},
              left: {value:0, hide:true},
              top: {value:0, hide:true},
              width: {value:"400px"},
              height: {value:"200px"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"none", hide:true},
              background: {value:"rgba(248, 249, 250)"},
            },
          },
        }
      ],
    },
    {
      id: 7,
      type: "Controls",
      items: [
        {
          id: 8,
          name: "Attachment",
          template: {
            id: 0,
            order: 0,
            type: "Attachment",
            properties: {
              name: {value: "Attachment",  control:"TextBox"},
              field: {value: "Attachment" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              toolTip: {value: true ,  control:"CheckBox"},
              toolTipText: {value: "" ,  control:"TextBox"},
              type: {value: "String" ,  control:"ListBox"},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: "",  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"},
              extension: {value: ".txt",  control:"ListBox"},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              display: {value:"flex", hide:true},
              alignItems: {value:"center", hide:true},
              width: {value:"100px"},
              height: {value:"25px"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 22,
          name: "AutoComplete",
          template: {
            id: 0,
            order: 0,
            type: "AutoComplete",
            properties: {
              name: {value: "AutoComplete",  control:"TextBox"},
              field: {value: "AutoComplete" ,  control:"TextBox"},
              type: {value: "String" ,  control:"ListBox"},
              actions: {value: "",  control:"TextBox"},
              toolTip: {value: true ,  control:"CheckBox"},
              toolTipText: {value: "" ,  control:"TextBox"},
              actualize: {value: 0,  control:"TextBox", hide:true},
              size: {value: 0,  control:"TextBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: {id: null,  item:""},  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"},
              placeholder: {value: "AutoComplete",  control:"TextBox"},
              data: {value:{ list:{}, mapping:{}}, options:["List", "Mapping"],  control:"TextBox"},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"150px"},
              height: {value:"25px"},
              display: {value:"flex", hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"1px solid #cccccc"},
              position: {value:"absolute"},
            },
          },
        },
        {
          id: 9,
          name: "CheckBox",
          template: {
            id: 0,
            order: 0,
            type: "CheckBoxLabel",
            properties: { 
              name: {value: "CheckBox",  control:"TextBox"},
              field: {value: "CheckBox" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              type: {value: "Boolean" ,  control:"ListBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: "",  control:"TextBox", hide:true}, 
              index: {value: false ,  control:"CheckBox"},
              operators: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                  {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              display: {value:"flex", hide:true},
              alignItems: {value:"center", hide:true},
              width: {value:"100px"},
              height: {value:"25px"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 12,
          name: "DateTime",
          template: {
            id: 0,
            order: 0,
            type: "DateTime",
            properties: {
              name: {value: "DateTime" ,  control:"TextBox"},
              field: {value: "DateTime" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              type: {value: "DateTime" ,  control:"ListBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: "",  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"},
              date: {value: true,  control:"CheckBox"},
              dateFormat: {value: "dd/mm/yyyy",
              values:[
                {id: "1",  item:"dd/mm/yyyy",  value:"dd/mm/yyyy"},
                {id: "2",  item:"mm/dd/yyyy",  value:"mm/dd/yyyy"},
                {id: "3",  item:"yyyy/mm/dd",  value:"yyyy/mm/dd"},
                {id: "4",  item:"yyyy/dd/mm",  value:"yyyy/dd/mm"}
              ]
              ,  type:"Date",  control:"ListBox"},
              time: {value: false,  control:"CheckBox"},
              timeFormat: {value: "hh:mm:ss",
              values:[
                {id: "1",  item:"hh:mm:ss",  value:"hh:mm:ss"},
                {id: "2",  item:"hh:mm",  value:"hh:mm"},
                {id: "3",  item:"hh",  value:"hh"},
                {id: "4",  item:"mm",  value:"mm"},
                {id: "5",  item:"ss",  value:"ss"}
              ]
              ,  type:"Time",  control:"ListBox"},
              operators: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                  {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                  {id: "3",  item:"greater",  value:{id:"3",  type:"greater"}},
                  {id: "4",  item:"greater & equal",  value:{id:"4",  type:"greater & equal"}},
                  {id: "5",  item:"lower",  value:{id:"5",  type:"lower"}},
                  {id: "6",  item:"lower & equal",  value:{id:"6",  type:"lower & equal"}}
                ]
              },
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              height: {value:"25px"},
              width: {value:"170px"},
              display: {value:"flex", hide:true},
              alignItems: {value:"center", hide:true},
             
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 13,
          name: "DataGrid",
          template: {
            id: 0,
            order: 0,
            currentMaxId: 0,
            type: "DataGrid",
            selectedValues: [],
            properties: {
              name: {value: "DataGrid",  control:"TextBox"},
              text: {value: "DataGrid",  control:"TextBox"},
              sliceStart: {value: 1,  control:"TextBox"},
              sliceSize: {value: 10,  control:"TextBox"},
              size: {value: 0,  control:"TextBox", hide:true},
              actualize: {value: 0,  control:"TextBox", hide:true},
              search: {value: true,  control:"CheckBox"},
              header: {value: true,  control:"CheckBox"},
              filter: {value: true,  control:"CheckBox"},
              actions: {value: "",  control:"TextBox"},
              add: {value: true,  control:"CheckBox"},
              delete: {value: true,  control:"CheckBox"},
              data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}, input:{}}, options:["Mapping"], control:"TextBox"}
            },
            metaData: [
              
              {
                  id: 0,
                  order: 0,
                  currentMaxId: 0,
                  type: "SearchGrid",
                  properties: {
                    name: {value: "SearchGrid",  control:"TextBox"},
                    text: {value: "SearchGrid",  control:"TextBox"},
                  },
                  metaData: [],                    
                  policy: { read: true, edit: true, delete: true },
                  styles: {
                    fontSize: {value:"14px"},
                    fontFamily: {value:"Arial"},
                    fontWeight: {value:"normal"},
                    fontStyle: {value:"normal"},
                    color: {value:"#212121"},
                    backgroundColor: {value:"#e7e7e7"},
                    height: {value:"30px"},
                    width: {value:"100%", hide:true},
                    display: {value:"flex", hide:true},
                    position: {value:"relative", hide:true},
                    boxSizing: {value:"border-box", hide:true},
                    overflow: {value:"hidden", hide:true},
                    border: {value:"1px solid #cccccc"},
                  },
               },
               {
                id: 0,
                order: 0,
                currentMaxId: 0,
                type: "Header",
                properties: {
                  name: {value: "Header",  control:"TextBox"},
                  text: {value: "Header",  control:"TextBox"},
                },
                metaData: [],                    
                policy: { read: true, edit: true, delete: true },
                styles: {
                  fontSize: {value:"14px"},
                  fontFamily: {value:"Arial"},
                  fontWeight: {value:"normal"},
                  fontStyle: {value:"normal"},
                  color: {value:"#cccccc"},
                  backgroundColor: {value:"#e7e7e7"},
                  height: {value:"30px"},
                  width: {value:"100%", hide:true},
                  display: {value:"flex", hide:true},
                  position: {value:"relative", hide:true},
                  boxSizing: {value:"border-box", hide:true},
                  overflow: {value:"hidden", hide:true},
                  border: {value:"1px solid #cccccc"}
                },
              },
              {
               id: 0,
               order: 0,
               currentMaxId: 0,
               type: "Filter",
               
               properties: {
                 name: {value: "Filter",  control:"TextBox"},
                 text: {value: "Filter",  control:"TextBox"},
               },
               metaData: [],                    
               policy: { read: true, edit: true, delete: true },
               styles: {
                 fontSize:{value: "14px"},
                 fontFamily: {value:"Arial"},
                 fontWeight: {value:"normal"},
                 fontStyle: {value:"normal"},
                 color: {value:"#cccccc"},
                 backgroundColor: {value:"white"},
                 height: {value:"30px"},
                 width: {value:"100%", hide:true},
                 display: {value:"flex", hide:true},
                 position: {value:"relative", hide:true},
                 boxSizing: {value:"border-box", hide:true},
                 overflow: {value:"hidden", hide:true},
                 border: {value:"1px solid #cccccc"}
               },
              },
              {
               id: 0,
               order: 0,
               currentMaxId: 0,
               type: "Rows",
               
               properties: {
                 name: {value: "Rows",  control:"TextBox"},
                 text: {value: "Rows",  control:"TextBox"},
               },
               metaData: [],                    
               policy: { read: true, edit: true, delete: true },
               styles: {
                 fontSize: {value:"14px"},
                 fontFamily: {value:"Arial"},
                 color: {value:"#cccccc"},
                 backgroundColor:{value: "white"},
                 height: {value:"30px"},
                 width: {value:"100%", hide:true},
                 display: {value:"flex", hide:true},
                 position: {value:"relative", hide:true},
                 boxSizing: {value:"border-box", hide:true},
                 overflow: {value:"hidden", hide:true},
                 border: {value:"1px solid #cccccc"}
               },
              }
            ],
            
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              color: {value:"#cccccc"},
             
              width: {value:"500px"},
              height: {value:"300px"},
              resize: {value:"both", hide:true},
              
              position: {value:"absolute", hide:true},
              boxSizing: {value:"border-box", hide:true},
              zIndex: {value:1, hide:true},
              backgroundColor: {value:"white"},
              border: {value:"1px solid #cccccc"},
              overflow: {value:"auto", hide:true},
             
              left: {value:10, hide:true},
              top: {value:50, hide:true},
            },
            excludesDropTypes: ["Label","DataGrid","Line","Radio","GroupBox","Button","RichTextBox","TreeBox", "TextEditor"],
            
          },
        },
        {
          id: 27,
          name: "TextEditor",
          template: {
            id: 0,
            order: 0,
            type: "TextEditor",
            properties: { 
              name: {value: "TextEditor",  control:"TextBox"},
              field: {value: "TextEditor" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              type: {value: "String" ,  control:"ListBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              showToolBar: {value: true ,  control:"CheckBox"},
              size: {value: 500 ,  control:"TextBox"},
              text: {value: "",  control:"TextBox"} ,
              index: {value: false ,  control:"CheckBox"},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              border:{value:"1px solid #cccccc"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"500px"},
              height: {value:"200px"},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 14,
          name: "HyperText",
          template: {
            id: 0,
            order: 0,
            type: "HyperText",
            properties: {
              name: {value: "HyperText",  control:"TextBox"},
              field: {value: "HyperText" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              type: {value: "String" ,  control:"ListBox", hide:true},
              toolTip: {value: true ,  control:"CheckBox"},
              toolTipText: {value: "" ,  control:"TextBox"},
              nullable: {value: true ,  control:"CheckBox"},              
              text: {value: "",  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              width: {value:"110px"},
              display: {value:"flex", hide:true},
              alignItems: {value:"center", hide:true},
              height: {value:"25px"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 15,
          name: "Label",
          template: {
            id: 0,
            order: 0,
            type: "Label",
            properties: { 
              name: {value: "Label",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              text: {value: "Label",  control:"TextBox"} ,
              readOnly: {value: true ,  control:"CheckBox", hide:true},
              eventInfo: {value: false ,  control:"CheckBox"}, 
              type: {
                value: "",  
                control:"ListBox",
                values:[
                  {id: "0",  item:"",  value:""},
                  {id: "1",  item:"H1",  value:"H1"},
                  {id: "2",  item:"H2",  value:"H2"},
                  {id: "3",  item:"H3",  value:"H3"},
                  {id: "4",  item:"H4",  value:"H4"},
                  {id: "5",  item:"H5",  value:"H5"},
                  {id: "6",  item:"H6",  value:"H6"},
                ]
              }
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              visibility: {value:"visible"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              paddingTop: {value:"3px", hide:true},
              height: {value:"25px"},
              border: {value:"none"},
              display: {value:"flex", hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              useSelect: {value:"none", hide:true},
            },
          },
        },
        {
          id: 16,
          name: "ListBox",
          template: {
            id: 0,
            order: 0,
            type: "ListBox",
            properties: {
              name: {value: "ListBox",  control:"TextBox"},
              field: {value: "ListBox" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              menuItem: {value: false ,  control:"CheckBox", hide:true},
              width: {value: "200px" ,  control:"TextBox"},
              type: {value: "String" ,  control:"ListBox" , hide:true},
              toolTip: {value: true ,  control:"CheckBox"},
              toolTipText: {value: "" ,  control:"TextBox"},
              actualize: {value: 0,  control:"TextBox", hide:true},
              size: {value: 0,  control:"TextBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: {id: null,  item:""},  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"},
              data: {value:{list:{}, mapping:{}, tree:{treeDataType:"Form"}}, options:["List", "Mapping"], control:"TextBox"},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"25px"},
              display: {value:"flex", hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              position: {value:"absolute"},
            },
          },
        },
        {
          id: 17,
          name: "Line",
          template: {
            id: 0,
            order: 0,
            type: "Line",
            properties: { 
              name: {value: "Line",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              text: {value: "Line",  control:"TextBox"} },
            policy: { read: true, edit: true, delete: true },
            styles: {
              width: {value:"100px"},
              height: {value:"2px"},
              color: {value:"#212121"},
              resize: {value:"horizontal"},
              overflow: {value:"auto"},
              left: {value:10},
              top: {value:50},
            },
          },
        },
        {
          id: 18,
          name: "Radio",
          template: {
            id: 0,
            order: 0,
            type: "Radio",
            properties: { 
              name: {value: "Radio",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              type: {value: "Boolean" ,  control:"ListBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              text: {value: "Radio",  control:"TextBox", hide:true},
              index: {value: false ,  control:"CheckBox"}
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              display: {value:"flex", hide:true},
              width: {value:"100px"},
              alignItems: {value:"center", hide:true},
              height: {value:"25px"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 19,
          name: "RichTextBox",
          template: {
            id: 0,
            order: 0,
            type: "RichTextBox",
            properties: { 
              name: {value: "RichTextBox",  control:"TextBox"},
              field: {value: "RichTextBox" ,  control:"TextBox"},
              actions: {value: "",  control:"TextBox"}, 
              type: {value: "String" ,  control:"ListBox", hide:true},
              nullable: {value: true ,  control:"CheckBox"},
              size: {value: 100 ,  control:"TextBox"},
              text: {value: "RichTextBox",  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"}, 
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}}
                ]
              },
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              height: {value:"100px"},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
            },
          },
        },
        {
          id: 20,
          name: "TextBox",
          template: {
            id: 0,
            order: 0,
            type: "TextBox",
            properties: { 
              name: {value: "TextBox",  control:"TextBox"}, 
              field: {value: "TextBox" ,  control:"TextBox"},
              text: {value: "",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              readOnly: {value: false ,  control:"CheckBox"},
              placeholder: {value: "" ,  control:"TextBox"},
              toolTip: {value: true ,  control:"CheckBox"}, 
              toolTipText: {value: "" ,  control:"TextBox"},
              maxLength: {value: 200 ,  control:"TextBox"},
              type: {value: "String",  
                control:"ListBox",
                values:[
                  {id: "0",  item:"String",  value:"String"},
                  {id: "1",  item:"Integer",  value:"Integer"},
                  {id: "2",  item:"Decimal",  value:"Decimal"},
                ]
              },
              masks: {value: "" ,  control:"TextBox", maskValue:""},
              validations: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"REQUIRE",  value: {id:"1",  type:"REQUIRE", events:["onBlur", "onSubmit"]}},
                  {id: "2",  item:"NUMBER",  value:{id:"2",  type:"NUMBER",events:["onChange", "onkeyPress"]}},
                  {id: "3",  item:"EMAIL",  value:{id:"3",  type:"EMAIL",events:["onBlur"]}},
                  {id: "4",  item:"UNIQUE",  value:{id:"4",  type:"UNIQUE",events:["onBlur"]}},
                  {id: "5",  item:"NOSPACE",  value:{id:"5",  type:"NOSPACE",events:["onkeyPress"]}},
                  {id: "6",  item:"NOSPECIALCHAR",  value:{id:"6",  type:"NOSPECIALCHAR",events:["onkeyPress"]}},
                  {id: "7",  item:"PATTERN",  value:{id:"7",  type:"PATTERN",events:["onBlur"]}}
                ]
              },
              operators: {
                value: "",  
                control:"ListBoxCheckBox",
                selectedValues:[],
                values:[
                  {id: "1",  item:"equal",  value: {id:"1",  type:"equal"}},
                  {id: "2",  item:"not equal",  value:{id:"2",  type:"not equal"}},
                  {id: "3",  item:"greater",  value:{id:"3",  type:"greater"}},
                  {id: "4",  item:"greater & equal",  value:{id:"4",  type:"greater & equal"}},
                  {id: "5",  item:"lower",  value:{id:"5",  type:"lower"}},
                  {id: "6",  item:"lower & equal",  value:{id:"6",  type:"lower & equal"}},
                  {id: "7",  item:"contains",  value:{id:"7",  type:"contains"}},
                  {id: "8",  item:"starts with",  value:{id:"8",  type:"starts with"}},
                  {id: "9",  item:"ends with",  value:{id:"9",  type:"ends with"}}
                ]
              },
              prefix: {value: "" ,  control:"TextBox"},
              suffix: {value: "" ,  control:"TextBox"},
              wholeNumberLength: {value: 10 ,  control:"TextBox"},
              decimalSize: {value: 2 ,  control:"TextBox"},
              decimalSeparator: {value: "" ,  control:"TextBox"},
              groupSize: {value: 3 ,  control:"TextBox"},
              groupSeparator: {value: "" ,  control:"TextBox"},
              index: {value: false ,  control:"CheckBox"}, 
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              fontSize: {value:"14px"},
              fontFamily: {value:"Arial"},
              fontWeight: {value:"normal"},
              fontStyle: {value:"normal"},
              color: {value:"#212121"},
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"100px"},
              display: {value:"flex", hide:true},
              height: {value:"25px"},
              visibility: {value:"visible"},
              borderLeft: {value:"1px solid #cccccc"},
              borderTop: {value:"1px solid #cccccc"},
              borderTopLeftRadius: {value:"2px"},
              borderTopRightRadius: {value:"2px"},
              borderRight: {value:"1px solid #cccccc"},
              borderBottom: {value:"1px solid #cccccc"},
              borderBottomLeftRadius: {value:"2px"},
              borderBottomRightRadius: {value:"2px"},
              background: {value:"white"},
              boxSizing: {value:"border-box", hide:true},
              textAlign: {value:"left"},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              useSelect: {value:"none", hide:true},
            },
          },
        },
        {
          id: 23,
          name: "TreeView",
          template: {
            id: 0,
            order: 0,
            type: "TreeBox",
            properties: {
              name: {value: "TreeBox",  control:"TextBox"},
              text: {value: "TreeBox",  control:"TextBox"},
              actions: {value: "",  control:"TextBox"},
              checkBox: {value: true,  type:"Boolean",  control:"CheckBox"},
              data: {value:{list:{}, mapping:{}, tree:{}}, options:["Tree"], control:"TextBox"}
            },
            policy: { read: true, edit: true, delete: true },
            styles: {
              
              left: {value:10, hide:true},
              top: {value:50, hide:true},
              width: {value:"150px"},
              height: {value:"25px"},
              display: {value:"flex", hide:true},
              boxSizing: {value:"border-box", hide:true},
              resize: {value:"both", hide:true},
              overflow: {value:"auto", hide:true},
              border: {value:"1px solid #cccccc"},
              backgroundColor: {value:"white"},
            },
          },
        }
      ],
    },
  ],
  formData: {
    lists: {
      currentMaxId: 1,
      globalId: 1,
      validations: {
        properties:{
          name:{ onkeyPress: [{ type:"NOSPACE"},{ type:"NOSPECIALCHAR"}], onBlur: [{ type:"REQUIRE"},{ type:"UNIQUE"}]
            ,replacesValues : [{old: "$title", new: "name"},{old: "$field", new: "name"}],options : ["Text"]},
          text:{ replacesValues : [{old: "$title", new: "text"},{old: "$field", new: "text"}]
            ,options : ["Text", "Conditions"]},
          actions:{ replacesValues : [{old: "$title", new: "actions"},{old: "$field", new: "actions"}]
            ,options : ["Text","Api"]},
          placeholder:{ replacesValues : [{old: "$title", new: "placeholder"},{old: "$field", new: "placeholder"}],options : ["Text"]},
          toolTip:{ replacesValues : [{old: "$title", new: "toolTip"},{old: "$field", new: "toolTip"}],options : ["Text"]},
          toolTipText:{ replacesValues : [{old: "$title", new: "toolTipText"},{old: "$field", new: "toolTipText"}],options : ["Text"]},
          field:{ replacesValues : [{old: "$title", new: "field"},{old: "$field", new: "field"}],options : ["Text"]},
          masks:{ replacesValues : [{old: "$title", new: "masks"},{old: "$field", new: "masks"}],options : ["Text"]},
          prefix:{ replacesValues : [{old: "$title", new: "prefix"},{old: "$field", new: "prefix"}],options : ["Text"]},
          suffix:{ replacesValues : [{old: "$title", new: "suffix"},{old: "$field", new: "suffix"}],options : ["Text"]},
          maxLength:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "maxLength"},{old: "$field", new: "maxLength"}],options : ["Text"]},
          wholeNumberLength:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "wholeNumberLength"},{old: "$field", new: "wholeNumberLength"}],options : ["Text"]},
          decimalSize:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "decimalSize"},{old: "$field", new: "decimalSize"}],options : ["Text"]},
          groupSize:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "groupSize"},{old: "$field", new: "groupSize"}],options : ["Text"]},
          groupSeparator:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "groupSeparator"},{old: "$field", new: "groupSeparator"}],options : ["Text"]},
          size:{ onkeyPress: [{ type:"NUMBER"}],replacesValues : [{old: "$title", new: "size"},{old: "$field", new: "size"}],options : ["Text"]},
          data:{replacesValues : [{old: "$title", new: "data"},{old: "$field", new: "data"}],options : ["List", "Mapping"]},
        },
        styles:{
          color:{ replacesValues : [{old: "$title", new: "color"},{old: "$field", new: "color"}], options : ["Text", "Conditions"]},
          fontSize:{ replacesValues : [{old: "$title", new: "fontSize"},{old: "$field", new: "fontSize"}], options : ["Text", "Conditions"]},
          fontFamily:{ replacesValues : [{old: "$title", new: "fontFamily"},{old: "$field", new: "fontFamily"}], options : ["Text", "Conditions"]},
          fontWeight:{ replacesValues : [{old: "$title", new: "fontWeight"},{old: "$field", new: "fontWeight"}], options : ["Text", "Conditions"]},
          fontStyle:{ replacesValues : [{old: "$title", new: "fontStyle"},{old: "$field", new: "fontStyle"}], options : ["Text", "Conditions"]},
          background:{ replacesValues : [{old: "$title", new: "background"},{old: "$field", new: "background"}], options : ["Text", "Conditions"]},
          backgroundColor:{ replacesValues : [{old: "$title", new: "background"},{old: "$field", new: "background"}], options : ["Text", "Conditions"]},
          border:{ replacesValues : [{old: "$title", new: "border"},{old: "$field", new: "border"}], options : ["Text", "Conditions"]}
        },
        events:{
          api:{ options : ["Params", "Authorization", "Headers", "Body", "Response", "Schemas"],
                response : {options:["Content", "Cookies"]},
                schemas : {options:["Content", "Cookies"]},
                body : {options:["raw", "form-data", "x-www-form-urlencoded"]},
                methods : [{id:1, item:"GET"}, {id:2, item:"POST"}, {id:3, item:"PUT"}, {id:4, item:"PATCH"}],
                callTypes : [{id:1, item:"SYNC"}, {id:2, item:"ASYNC"}],
                rawTypes : [{id:1, item:"Text"}, {id:2, item:"JSON"}, {id:3, item:"GraphQL"}, {id:4, item:"XML"}],
                params : [{id:1, item:"Auth"}, {id:2, item:"Body"}, {id:3, item:"Headers"}],
                headers : { 
                  key : [{id:1, item:"Access-Control-Allow-Credentials"}, {id:2, item:"Access-Control-Allow-Headers"}, {id:3, item:"Access-Control-Allow-Methods"}, {id:4, item:"Access-Control-Allow-Origin"},
                         {id:5, item:"Access-Control-Expose-Headers"}, {id:6, item:"Access-Control-Max-Age"}, {id:7, item:"Accept-Ranges"}, {id:8, item:"Age"}, {id:9, item:"Allow"}, {id:10, item:"Alternate-Protocol"},
                         {id:11, item:"Cache-Control"}, {id:12, item:"Client-Date"}, {id:13, item:"Client-Peer"}, {id:14, item:"Client-Response-Num"}, {id:15, item:"Connection"}, {id:16, item:"Content-Disposition"},
                         {id:17, item:"Content-Encoding"}, {id:18, item:"Content-Language"}, {id:19, item:"Content-Length"}, {id:20, item:"Content-Location"}, {id:21, item:"Content-MD5"}, {id:22, item:"Content-Range"},
                         {id:23, item:"Content-Security-Policy, X"}, {id:24, item:"Content-Security-Policy, X-WebKit-CSP"}, {id:25, item:"Content-Security-Policy-Report-Only"}, {id:26, item:"Content-Type"}, {id:27, item:"Date"}, {id:28, item:"ETag"},
                         {id:29, item:"Expires"}, {id:30, item:"HTTP"}, {id:31, item:"Keep-Alive"}, {id:32, item:"Last-Modified"}, {id:33, item:"Link"}, {id:34, item:"Location"}, {id:35, item:"P3P"}, {id:36, item:"Pragma"},
                         {id:37, item:"Proxy-Authenticate"}, {id:38, item:"Proxy-Connection"}, {id:39, item:"Refresh"}, {id:40, item:"Retry-After"}, {id:41, item:"Server"}, {id:42, item:"Set-Cookie"}, {id:43, item:"Status"}, {id:44, item:"Strict-Transport-Security"},
                         {id:45, item:"Timing-Allow-Origin"}, {id:46, item:"Trailer"}, {id:47, item:"Transfer-Encoding"}, {id:48, item:"Upgrade"}, {id:49, item:"Vary"}, {id:50, item:"Via"}, {id:51, item:"Warning"}, {id:52, item:"WWW-Authenticate"},
                         {id:53, item:"X-Aspnet-Version"}, {id:54, item:"X-Content-Type-Options"}, {id:55, item:"X-Frame-Options"}, {id:56, item:"X-Permitted-Cross-Domain-Policies"}, {id:57, item:"X-Pingback"}, {id:58, item:"X-Powered-By"}, 
                         {id:59, item:"X-Robots-Tag"}, {id:60, item:"X-UA-Compatible"},{id:61, item:"X-XSS-Protection"}
                ],
                  value : [{id:1, item:"application/java-archive"}, {id:2, item:"application/EDI-X12"}, {id:3, item:"application/EDIFACT"}, {id:4, item:"application/javascript"},
                         {id:5, item:"application/octet-stream"}, {id:6, item:"application/ogg"}, {id:7, item:"application/pdf"}, {id:8, item:"application/xhtml+xml"}, {id:9, item:"application/x-shockwave-flash"}, {id:10, item:"application/json"},
                         {id:11, item:"application/ld+json"}, {id:12, item:"application/xml"}, {id:13, item:"application/zip"}, {id:14, item:"application/x-www-form-urlencoded"}, {id:15, item:"audio/mpeg"}, {id:16, item:"audio/x-ms-wma"},
                         {id:17, item:"audio/vnd.rn-realaudio"}, {id:18, item:"audio/x-wav"}, {id:19, item:"image/gif"}, {id:20, item:"image/jpeg"}, {id:21, item:"image/png"}, {id:22, item:"image/tiff"},
                         {id:23, item:"image/vnd.microsoft.icon"}, {id:24, item:"image/x-icon"}, {id:25, item:"image/vnd.djvu"}, {id:26, item:"image/svg+xml"}, {id:27, item:"multipart/mixed"}, {id:28, item:"multipart/alternative"},
                         {id:29, item:"multipart/related"}, {id:30, item:"multipart/form-data"}, {id:31, item:"text/css"}, {id:32, item:"text/csv"}, {id:33, item:"text/html"}, {id:34, item:"text/javascript"}, {id:35, item:"text/plain"}, {id:36, item:"text/xml"},
                         {id:37, item:"video/mpeg"}, {id:38, item:"video/mp4"}, {id:39, item:"video/quicktime"}, {id:40, item:"video/x-ms-wmv"}, {id:41, item:"video/x-msvideo"}, {id:42, item:"video/x-flv"}, {id:43, item:"video/webm"}, {id:44, item:"application/vnd.android.package-archive"},
                         {id:45, item:"application/vnd.oasis.opendocument.text"}, {id:46, item:"application/vnd.oasis.opendocument.spreadsheet"}, {id:47, item:"application/vnd.oasis.opendocument.presentation"}, {id:48, item:"application/vnd.oasis.opendocument.graphics"}, 
                         {id:49, item:"application/vnd.ms-excel"}, {id:50, item:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}, {id:51, item:"application/vnd.ms-powerpoint"}, {id:52, item:"application/vnd.openxmlformats-officedocument.presentationml.presentation"},
                         {id:53, item:"application/msword"}, {id:54, item:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"}, {id:55, item:"application/vnd.mozilla.xul+xml"}, {id:56, item:"true"}, {id:57, item:"false"}]
                }
              },
          onLoad:{ replacesValues : [{old: "$title", new: "color"},{old: "$field", new: "color"}], options : ["Text", "Conditions"]},
        },
        step:{
          decision:{ replacesValues : [{old: "$title", new: "Step"},{old: "$field", new: "Step"}], options : ["Conditions"]},
          api:{ replacesValues : [{old: "$title", new: "Step"},{old: "$field", new: "Step"}], options : ["Api"]},
        }
      },
    },
    log: [{type:"ADD", value: "Add $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
      ,{type:"SELECT", value: "Select $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
      ,{type:"UPDATE", value: "Update $title", style: {fontFamily:"sans-serif",fontWeight:"normal",color : "Black"} }
      ,{type:"DELETE", value: "Commit deleting", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "rgb(206, 17, 38)"} }
      ,{type:"LEAVE", value: "You have unsaved changes", style: {fontFamily:"sans-serif",fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"DISCARD", value: "Commit discard", style: {fontFamily:"sans-serif",fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"REQUIRE", value: "The $field is required", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"UNIQUE", value: "This $field already exist", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"EMAIL", value: "The input of $field is not valid email", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"JSON", value: "The input is not valid json", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }
      ,{type:"XML", value: "The input is not valid xml", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }
    ],
    menu:{
      operation : {Add:"ADD", Update:"UPDATE", Delete:"DELETE", Select:"SELECT", Discard:"DISCARD"},
      type : {media:"media", version:"version", language:"language", field:"field"
        , firstOperand:"firstOperand", secondOperand:"secondOperand", key:"key", value:"value", form:"form"},
      media :{ options : [{id:1, item:"Min"},{id:2, item:"Max"}]
               ,validations : { onkeyPress: [{ type:"NUMBER"}], onBlur: [{ type:"REQUIRE"}]}
               ,replacesValues : [{old: "$title", new: "media"},{old: "$field", new: "width"}]
              },
               
      version :{ 
        validations : { onBlur: [{ type:"REQUIRE"}]},
        replacesValues : [{old: "$title", new: "version"},{old: "$field", new: "version"}]
      },
      language :{replacesValues : [{old: "$title", new: "language"}] },
      operator:{ options: [{id: "0", item: "="},{id: "1", item: "<>"},{id: "2", item: ">"},{id: "3", item: "<"},{id: "4", item: ">="},{id: "5", item: "<="}]},
      firstOperand :{ 
        validations : { onBlur: [{ type:"REQUIRE"}]},
        replacesValues : [{old: "$title", new: "firstOperand"},{old: "$field", new: "firstOperand"}] },
      secondOperand :{ 
        validations : { onBlur: [{ type:"REQUIRE"}]},
        replacesValues : [{old: "$title", new: "secondOperand"},{old: "$field", new: "secondOperand"}] },
      key :{ 
        validations : { onBlur: [{ type:"REQUIRE"}]},
        replacesValues : [{old: "$title", new: "key"},{old: "$field", new: "key"}] },
      value :{ 
        validations : { },
        replacesValues : [{old: "$title", new: "value"},{old: "$field", new: "value"}] },
      field :{ 
        validations : { onBlur: [{ type:"REQUIRE"}]},
        replacesValues : [{old: "$title", new: "field"},{old: "$field", new: "field"}] },
           
      
      form :{}
    },
    metasData:[{id : 0, isSealed:false, version:{value:"1.0.0"}, language:{id:1, value:"English"}
    , media:{type:"Min", value:"600"}, values:initialMetaData}
    ],
    metaData: initialMetaData,
    currentTool: initialMetaData,
    currentMetaData : {id:0, maxId:0,  isSealed:false} ,
    actions : { 
      validation : {type: {Number:"NUMBER", Email:"EMAIL", Require:"REQUIRE", Size:"SIZE", Unique:"UNIQUE", NoSpace:"NOSPACE", NoSpecialChar:"NOSPECIALCHAR", Json:"JSON", Xml:"XML"}},
      event : {
        type: {onLoad:"onLoad", onkeyPress:"onkeyPress", onChange:"onChange", onMouseOver: "onMouseOver", onMouseLeave:"onMouseLeave", onMouseEnter:"onMouseEnter"
        , onBlur: "onBlur", onMouseDown: "onMouseDown", onClick: "onClick", onSubmit: "onSubmit"},
        lists:[{id:1, item:"onLoad"},{id:2, item:"onChange"},{id:3, item:"onClick"}
        ,{id:4, item:"onMouseOver"},{id:5, item:"onMouseLeave"}
        ,{id:6, item:"onBlur"},{id:7, item:"onSubmit"},{id:8, item:"onMouseEnter"}]
      },
      replacesValues: {field:"$field", title:"$title"},
      option : {text:"Text", condition:"Conditions", api: "Api", mapping: "Mapping", list: "List", tree: "Tree"},
      api : {params:"Params", authorization:"Authorization", headers: "Headers", body: "Body"
            , response: "Response", schemas: "Schemas", content: "Content", cookies: "Cookies"
            , formdata: "form-data", xwwwformurlencoded: "x-www-form-urlencoded", raw: "raw"
            , type: {key:"key", value:"value", destination:"destination"}},
      condition : {type: {firstOperand:"firstOperand", secondOperand:"secondOperand", operator:"operator"}}
    },
    currentDragOver: [],
    isEditTool: false,
    data: {},
    tree:[],
    errors:[],
    excludesFromSchemas : ["Button", "Label", "Line", "SearchGrid", "Header", "Filter", "Row"],
    excludesFromData : ["Button", "Label", "Line", "SearchGrid", "Header", "Filter", "Rows"],
  },
  historiques:{current:0 , values: []},
  languages : { 
    current:{id : 1 } 
    , options: [
      {id : 1, item:"English" , shortName:"En"},
      {id : 2, item:"French" , shortName:"Fr"}
    ]
  },
  variables:{
    users :[{id:"71542fc5-4408-43f1-8751-35c82f5bec79", item:"@CurrentUser", isExpanded:false, isChecked:false, 
      childs:[
        {id:"4e1bc5a3-4362-4325-9045-3361439b4aa8", item:"@EMail", isExpanded:false, isChecked:false, childs:[]},
        {id:"2e2e06a4-8016-45c0-a539-cf95b9ddc542", item:"@FirstName", isExpanded:false, isChecked:false, childs:[]},
        {id:"0e04765c-8302-478a-8d6a-63aeb4a1a54b", item:"@LastName", isExpanded:false, isChecked:false, childs:[]},
        {id:"4c24c084-d275-45f1-85e1-d634495ad230", item:"@Sexe", isExpanded:false, isChecked:false, childs:[]},
        {id:"d6ad5e2b-0bc7-4018-ab12-2dfc78f77cf6", item:"@BirthdayDate", isExpanded:false, isChecked:false, childs:[]},
        {id:"3deaa5ec-6dbe-4e80-be42-a6399ac720c9", item:"@BirthdayYear", isExpanded:false, isChecked:false, childs:[]},
        {id:"ec13b55a-209c-46ec-9b66-88ad39b537b0", item:"@BirthdayMonth", isExpanded:false, isChecked:false, childs:[]},
      ]}],
    times :[{id:"71542fc5-4408-43f1-8751-35c82f5bec79", item:"@CurrenTime", isExpanded:false, isChecked:false, 
      childs:[
        {id:"d323e04c-2201-4e5b-ad07-1dcc7e5d9397", item:"@DateTime", isExpanded:false, isChecked:false, childs:[]},
        {id:"6c51f58c-bbb8-4236-aae4-5d230c2b0eb1", item:"@Date", isExpanded:false, isChecked:false, childs:[]},
        {id:"9f3c568f-9da7-451d-aa32-b63f03ce7bdd", item:"@Time", isExpanded:false, isChecked:false, childs:[]}
      ]}]
  },
  authenticate:false,
  accessToken:""
};
const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
 

   
    switch (action.type) {
      case "SET_PROCESS_SETTINGS":
        return {
          ...state,
          processItems: action.payload,
        };
      case "SET_ORGANIGRAM_SETTINGS":
        return {
          ...state,
          organigramItems: action.payload,
        };
      case "CLICK_PROCESS_MENU":
        return {
          ...state,
          processItems: action.payload,
        };
      case "CLICK_ORGANIGRAM_MENU":
        return {...state,
          organigramItems: action.payload,
        };
      case "UPDATE_FORM":
        var newFormData = action.payload
        newFormData.metasData.filter(current => current.id == newFormData.currentMetaData.id).map(current => current.values = newFormData.metaData)
        const prevValues = state.historiques.values.length == 0 ? [state.formData] 
        : state.historiques.values.slice(0, state.historiques.current + 1)
        
        return {...state,
          formData: newFormData,
          languages: state.languages,
          historiques: {current:state.historiques.current +1  
            , values: [...prevValues, newFormData]}
        };
      case "INITIALIZE_FORM":
        
        var stateValue = {...state,
          formData: {...state.formData, ...action.payload.formData},
          historiques: {current:0, values: []},
          previousForms:action.payload.previousForms != undefined ? action.payload.previousForms : state.previousForms,
          currentDragOver:[],
          customFormData: action.payload.isCustomHome ? action.payload.formData : state.customFormData
        }
        stateValue.formData.lists["validations"] = state.formData.lists.validations
        //SET_STEP
        if (action.payload.setStepValue)
          stateValue["step"] = {profils: action.payload.setStepValue.profils, decisions:action.payload.setStepValue.decisions}
        return stateValue;
      case "REFRESH_FORM":
        var stateValue = {...state,
          formData: {...state.formData
            , metaData:initialMetaData
            , metasData:[{id : 0, isSealed:false, version:{value:"1.0.0"}, language:{id:1, value:"English"}
              , media:{type:"Min", value:"600"}, values:initialMetaData}]
            , currentTool:initialMetaData
            , lists:{...state.formData.lists, id:1, globalId:1}
            , currentMetaData:{id:0, maxId:0,  isSealed:false},
                    
          },
          historiques: {current:0, values: []},
          previousForms: action.payload.previousForms ? action.payload.previousForms : state.previousForms,
          currentDragOver:[]
        }
        stateValue.formData.lists["validations"] = state.formData.lists.validations
        //SET_STEP
        if (action.payload.setStepValue)
          stateValue["step"] = {profils: action.payload.setStepValue.profils, decisions:action.payload.setStepValue.decisions}
        return stateValue;
      case "SET_PREVIOUS_FORM":
        return {
          ...state,
          previousForms: action.payload,
        };
      case "UPDATE_FORM_WITOUT_HISTORIQUE":
        var newFormData = action.payload
        newFormData.metasData
        .filter(current => current.id == newFormData.currentMetaData.id)
        .map(current => current.values = newFormData.metaData)
        
        return {...state,
          formData: newFormData,
          languages: state.languages,
          historiques: state.historiques
        };
      case "PREV_FORM":
        var newFormData = action.payload
        newFormData.metasData
        .filter(current => current.id == newFormData.currentMetaData.id)
        .map(current => current.values = newFormData.metaData)
        
        return {...state,
          formData: newFormData,
          languages: state.languages,
          historiques: {current:state.historiques.current - 1 , values: state.historiques.values}
        };
      case "NEXT_FORM":
        var newFormData = action.payload
        newFormData.metasData
        .filter(current => current.id == newFormData.currentMetaData.id)
        .map(current => current.values = newFormData.metaData)
        
        return {...state,
          formData: newFormData,
          languages: state.languages,
          historiques: {current:state.historiques.current + 1 , values: state.historiques.values}
        };
      case "SET_AUTHENTIFICATION":
        return {
          ...state,
          accessToken: action.payload.accessToken,
        };
      case "SET_ACCESS_TOKEN":
        
        return {...state,
          company: action.payload.company ? action.payload.company : state.company,
          authenticate: true,
          user: action.payload.user ? action.payload.user : state.user,
          accessToken: action.payload.accessToken,
        };
      case "SET_STEP":
        return {
          ...state,
          step: {profils: action.payload.profils, decisions:action.payload.decisions},
        };
      case "SET_META_DATA":
        return {
          ...state,
          formData: {...state.formData
              , metaData:action.payload.metaData
              , data: {}
              , apiSchemas : action.payload.apiSchemas
              , lists:{...state.formData.lists, currentMaxId:action.payload.currentMaxId} 
              , metasData: [{...state.formData.metasData[0],  values:action.payload.metaData}] 
              , currentMetaData: action.payload.currentMetaData
        },
      };
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
